module.exports = __webpack_public_path__ + "static/24-7f663b23d5458f071105f19596b5e523.mp4";